/**
 * @file Asset board adapter.
 */

import { renderAssetKanban } from "../../shared/board/parentBoardKanban.js";
import { renderAssetWIPKanban } from "../../shared/board/parentBoardWipKanban.js";
import { renderAssetTable } from "../../shared/board/parentBoardTable.js";
import { createParentBoardAdapter } from "../../shared/board/parentBoardAdapterFactory.js";

export const assetBoardAdapter = createParentBoardAdapter({
  adapterKey: "asset",
  viewKey: "assets",
  renderers: {
    table: renderAssetTable,
    kanban: renderAssetKanban,
    wipKanban: renderAssetWIPKanban,
  },
});
